import React, { Component } from 'react';
import notify from 'devextreme/ui/notify';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react';
import { Col, Grid, Row } from 'react-bootstrap';
import "./login.css";

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginText: '',
            passwordText: '',
            checkCodeText: '',
            checkCodeTextVisible: false,
            checkCodeButtonVisible: false,
            getCodeDisabled: false,
            loginMessage: null
        };

        this.checkCodeTextBoxRef = React.createRef();
        this.passwordTextBoxRef = React.createRef();        

        this.focusPasswordTextBox = () => {
            this.passwordTextBox.focus()
        };

        this.focusCheckCodeTextBox = () => {
            this.checkCodeTextBox.focus()
        };

        this.onGetCodeClick = this.onGetCodeClick.bind(this);
        this.onCheckCodeClick = this.onCheckCodeClick.bind(this);
        this.onLoginChanged = this.onLoginChanged.bind(this);
        this.onPassChanged = this.onPassChanged.bind(this);
        this.onCheckCodeChanged = this.onCheckCodeChanged.bind(this);
        this.showCheckCode = this.showCheckCode.bind(this);
        this.hideCheckCode = this.hideCheckCode.bind(this);
        this.loginKeyPress = this.loginKeyPress.bind(this);
        this.passwordKeyPress = this.passwordKeyPress.bind(this);
        this.checkCodeKeyPress = this.checkCodeKeyPress.bind(this);
        this.getToken = this.getToken.bind(this);
        this.getCheckCode = this.getCheckCode.bind(this);
        this.requestPasswordClick = this.requestPasswordClick.bind(this);
    }

    get checkCodeTextBox() {
        return this.checkCodeTextBoxRef.current.instance;
    }

    get passwordTextBox() {
        return this.passwordTextBoxRef.current.instance;
    }

    requestPasswordClick() {
        var userData = {
            login: this.state.loginText,
            password: this.state.passwordText
        }

        fetch('api/main/requestPassword', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(userData)
            })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);                
            });
    }

    render() {
        return (
            <Grid>
                <div className="disclaimer"><div className="disclaimer-border">Личный кабинет находится в разработке, возможны технические сбои и некорректное отображение данных.</div></div>
                <Row className="justify-content-md-center">
                    <Col sm={4}>
                    </Col>
                    <Col sm={4}>
                        <Grid fluid id="loginGrid">
                            <Row>
                                <Col lg={12}>
                                    <img width="50" height="50" id="loginImage" src="../assets/lockoinvest_sign_background.png" /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <TextBox value={this.state.loginText} id="loginText"
                                        onValueChanged={this.onLoginChanged} onKeyPress={this.loginKeyPress}
                                        placeholder={'Логин'} type={Text} /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <TextBox value={this.state.passwordText} mode={'password'} onKeyPress={this.passwordKeyPress} ref={this.passwordTextBoxRef}
                                        onValueChanged={this.onPassChanged}
                                        placeholder={'Пароль'} /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div id="loginMessage">{this.state.loginMessage}</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div onClick={this.requestPasswordClick} className="clickDiv">Забыли пароль?</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <Button id="checkButton"
                                        text={'Получить код'}
                                        type={'normal'}
                                        stylingMode={'contained'}
                                        width={140}
                                        onClick={this.onGetCodeClick}
                                        disabled={this.state.getCodeDisabled}
                                    /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <TextBox value={this.state.checkCodeText} visible={this.state.checkCodeTextVisible} id="checkText" onKeyPress={this.checkCodeKeyPress} ref={this.checkCodeTextBoxRef}
                                             onValueChanged={this.onCheckCodeChanged} valueChangeEvent={'keyup'}
                                        placeholder={'Код подтверждения из SMS'} /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}><Button id="loginButton"
                                    text={'Подтвердить'}
                                    type={'normal'}
                                    stylingMode={'contained'}
                                    width={140}
                                    visible={this.state.checkCodeButtonVisible}
                                    onClick={this.onCheckCodeClick}
                                /></Col>
                            </Row>
                            <Row>
                                <Col lg={12}></Col>
                            </Row>
                        </Grid>


                    </Col>
                    <Col sm={4}>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col sm={4}>
                    </Col>
                    <Col sm={4}>

                    </Col>
                    <Col sm={4}>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col sm={4}>
                    </Col>
                    <Col sm={4}>

                    </Col>
                    <Col sm={4}>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col sm={4}>
                    </Col>
                    <Col sm={4}>

                    </Col>
                    <Col sm={4}>
                    </Col>
                </Row>
                <Row className="justify-content-md-center">
                    <Col sm={4}>
                    </Col>
                    <Col sm={4}>

                    </Col>
                    <Col sm={4}>
                    </Col>
                </Row>
            </Grid>
        );
    }

    passwordKeyPress(e) {
        if (e.event.code == "Enter" || e.event.code == "NumpadEnter") {
            this.setState({ passwordText: e.event.target.value, loginMessage: null });
            this.getCheckCode();
        }
    };

    loginKeyPress(e) {
        if (e.event.code == "Enter" || e.event.code == "NumpadEnter") {
            this.setState({ loginText: e.event.target.value, loginMessage: null });
            this.focusPasswordTextBox();
        }
    };

    checkCodeKeyPress(e) {
        if (e.event.code == "Enter" || e.event.code == "NumpadEnter") {
            this.getToken();
        }
    };

    onGetCodeClick(e) {
        this.getCheckCode();
    }

    getCheckCode() {
        var userData = {
            login: this.state.loginText,
            password: this.state.passwordText
        }

        fetch('api/account/checkLogin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(userData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.isSucceeded == true) {
                    if (data.message == "client") {
                        this.showCheckCode();
                    } else {
                        this.getToken()
                    }
                }
                else {
                    this.setState({ loginMessage: data.message });
                }
            });
    }

    showCheckCode() {
        this.setState({ checkCodeTextVisible: true, checkCodeButtonVisible: true, getCodeDisabled: true });
        this.focusCheckCodeTextBox();
    }

    hideCheckCode() {
        this.setState({ checkCodeTextVisible: false, checkCodeButtonVisible: false, getCodeDisabled: false });
    }

    onCheckCodeClick(e) {
        this.getToken();
    }

    getToken() {
        var tokenKey = "accessToken";

        var userData = {
            login: this.state.loginText,
            password: this.state.passwordText,
            smsCode: this.state.checkCodeText
        }

        fetch('api/account/token', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(userData)
        })
            .then(response => response.json())
            .then(data => {
                if (data.isSucceeded == true) {
                    sessionStorage.setItem(tokenKey, data.data.accessToken);
                    sessionStorage.setItem("userName", data.data.fullName);
                    window.location.reload(false);
                    window.location.href = data.data.startLocation;
                }
                else {
                    this.setState({ loginMessage: data.message, checkCodeText: null });
                    this.hideCheckCode();
                }                
            });
    }

    onLoginChanged(e) {
        this.setState({ loginText: e.value, loginMessage: null });
        this.hideCheckCode();
    }

    onPassChanged(e) {
        this.setState({ passwordText: e.value, loginMessage: null });
        this.hideCheckCode();
    }

    onCheckCodeChanged(e) {
        this.setState({ checkCodeText: e.value });        
    }
}


// WEBPACK FOOTER //
// ./App/containers/login/login.jsx